
const SPECIAL_CHARS = /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/~`';]/

export const MIN_PASSWORD_LENGTH = 8

/**
 * Requisitos
 */
export const passwordChecks = [
  { label: `Al menos ${MIN_PASSWORD_LENGTH} caracteres`, test: v => (v || '').length >= MIN_PASSWORD_LENGTH },
  { label: 'Una letra mayuscula', test: v => /[A-Z]/.test(v || '') },
  { label: 'Una letra minuscula', test: v => /[a-z]/.test(v || '') },
  { label: 'Un numero', test: v => /\d/.test(v || '') },
  { label: 'Un caracter especial', test: v => SPECIAL_CHARS.test(v || '') },
]

export const passwordRules = [
  v => !!v || 'Este campo es obligatorio',
  v => (v || '').length >= MIN_PASSWORD_LENGTH || `Debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres`,
  v => /[A-Z]/.test(v || '') || 'Debe tener al menos una letra mayuscula',
  v => /[a-z]/.test(v || '') || 'Debe tener al menos una letra minuscula',
  v => /\d/.test(v || '') || 'Debe tener al menos un numero',
  v => SPECIAL_CHARS.test(v || '') || 'Debe tener al menos un caracter especial',
]

/**
 * Variante para formularios donde la contrasena es opcional
 */
export const optionalPasswordRules = [
  v => !v || (v || '').length >= MIN_PASSWORD_LENGTH || `Debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres`,
  v => !v || /[A-Z]/.test(v) || 'Debe tener al menos una letra mayuscula',
  v => !v || /[a-z]/.test(v) || 'Debe tener al menos una letra minuscula',
  v => !v || /\d/.test(v) || 'Debe tener al menos un numero',
  v => !v || SPECIAL_CHARS.test(v) || 'Debe tener al menos un caracter especial',
]

/**
 * Cantidad de requisitos cumplidos.
 */
export function passwordScore (password) {
  if (!password) return 0

  return passwordChecks.filter(check => check.test(password)).length
}
